import { EventType } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { configService } from './service';

const MsalWrapper = (props) => {
    const { instance, accounts } = useMsal();
    const [authSuccess, setAuthSuccess] = useState(false);

    useEffect(() => {
        (async () => {
            if (!authSuccess) {
                // Set active account on page load
                if (accounts.length > 0) {
                    if (accounts[0].environment.includes('login.windows.net') && sessionStorage.getItem('isInternal') === 'true') {
                        instance.setActiveAccount(accounts[0]);
                    } else {
                        instance.logout();
                    }
                }

                await instance.initialize();

                instance.addEventCallback(
                    (event) => {
                        // set active account after redirect
                        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
                            const account = event.payload.account;
                            instance.setActiveAccount(account);
                        }
                    },
                    (error) => console.error('error', error)
                );

                let loginRequest = undefined;
                if (sessionStorage.getItem('isInternal') === 'true') {
                    // Azure AD login
                    loginRequest = configService.azureAdMsal.scope.scopes;
                } else {
                    // Azure B2C login
                    loginRequest = configService.azureB2CMsal.scope.scopes;
                }

                instance
                    .handleRedirectPromise()
                    .then(async (authResult) => {
                        // Check if user signed in
                        const account = instance.getActiveAccount();

                        if (!account) {
                            // redirect anonymous user to login page
                            await instance.loginRedirect(loginRequest);
                        }

                        setAuthSuccess(true);
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }
        })();
    }, [authSuccess]);

    return <>{authSuccess ? props.children : <div>Trying to authenticate user...</div>}</>;
};

export default MsalWrapper;
